module.exports = __webpack_public_path__ + "static/img/favicon.897e904.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.ico
// module id = 43FW
// module chunks = 1